export const ProjectTypeEnum = {
  REVOLVING: "REVOLVING",
  ONE_TIME: "ONE_TIME",
}

export const ProjectTypeList = [
  "REVOLVING",
  "ONE_TIME",
]
